import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, Trophy, X } from 'lucide-react';
import { humanizeFamilyId } from '../../content';
import { playSoundIntent } from '../../utils/sound/soundIntent';
import { hapticManager } from '../../utils/hapticManager';
interface NewlyUnlockedBannerProps {
  familyId: string | null;
  onClick: () => void;
  onClose: () => void;
}
export function NewlyUnlockedBanner({
  familyId,
  onClick,
  onClose
}: NewlyUnlockedBannerProps) {
  // F-FEEL-9: celebrate the click — sound + haptic before opening the challenge
  const handleClick = () => {
    playSoundIntent('reward.streak');
    hapticManager.hapticMedium();
    onClick();
  };
  return <AnimatePresence data-id="element-3070" data-mp="3bqrgcyd075sp">
      {familyId && <motion.div initial={{
      opacity: 0,
      y: -20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      bounce: 0.4,
      duration: 0.6
    }} className="relative z-10" data-id="element-3071" data-mp="3brt1xwrnbaoo">
          <button onClick={handleClick} className="w-full text-left bg-gradient-to-r from-amber-400 to-orange-500 p-1 rounded-2xl shadow-xl shadow-orange-500/20 hover:scale-[1.02] active:scale-[0.98] transition-transform" data-id="element-3072" data-mp="mu7a62uy7vmx">
            <div className="bg-white rounded-xl p-4 flex items-center gap-4 relative overflow-hidden" data-id="element-3073" data-mp="11shr0620lofw">
              <div className="absolute -right-4 -top-4 text-orange-100 opacity-50 transform rotate-12" data-id="element-3074" data-mp="16j7zvt9ng9fc">
                <Trophy className="w-24 h-24" data-id="element-3075" data-mp="1all3ab0xbv8y" />
              </div>

              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 relative z-10 shadow-sm" data-id="element-3076" data-mp="1fkfvu4op0y69">
                <Trophy className="w-6 h-6 text-orange-500" data-id="element-3077" data-mp="1kkkb5rdv7muw" />
              </div>

              <div className="flex-1 relative z-10" data-id="element-3078" data-mp="3gm45b9na063d">
                <div className="text-xs font-bold text-orange-500 uppercase tracking-wider mb-0.5 flex items-center gap-1" data-id="element-3079" data-mp="3gkkrrqt0895a">
                  <Sparkles className="w-3 h-3" data-id="element-3080" data-mp="3qcgszaqe0fdq" />
                  Uitdaging ontgrendeld!
                </div>
                <div className="text-slate-800 font-medium text-sm md:text-base" data-id="element-3081" data-mp="3ll8h881l4hxe">
                  Je hebt 70% gehaald voor{' '}
                  <span className="font-bold" data-id="element-3082" data-mp="36fz2ukwob2u">
                    {humanizeFamilyId(familyId)}
                  </span>
                  . Klik hier om te starten!
                </div>
              </div>

              <div onClick={e => {
            e.stopPropagation();
            onClose();
          }} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors relative z-10" aria-label="Sluiten" data-id="element-3083" data-mp="d5f0bs3cd4ft">
                <X className="w-5 h-5" data-id="element-3084" data-mp="pfmt4ts4uhcc" />
              </div>
            </div>
          </button>
        </motion.div>}
    </AnimatePresence>;
}